import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"

const AnjuAllArtworkStatic = () => {
    return (
      <>
        <div class="masonry-wrap">

            <Masonry columnsCount={2} gutter={"0.75em"}>

                <div>
                        <img src="https://pbs.twimg.com/media/Fjy_P1KXkBY2AJc?format=jpg&name=large"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/d97YdkH.jpg"/>                  
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1MAZH3oa2TUTMG4Bu7SGnMVhW2Ms2ePBgL/2" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/OjvBiU7.jpeg"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1MAZH3oa2TUTMG4Bu7SGnMVhW2Ms2ePBgL/1" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/ipEN0pq.jpeg"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1MAZH3oa2TUTMG4Bu7SGnMVhW2Ms2ePBgL/0" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/w5ZF20r.jpeg"/>                  
                    </a> 
                </div>

                <div>
                  <a href="https://foundation.app/@ANJUonline/anju/1" target="_blank" rel="noopener noreferrer">
                    <img src="https://f8n-production-collection-assets.imgix.net/0x1f597E08f4e7428845EB693d9F49B33f07eF04eD/1/nft.png?q=80&auto=format%2Ccompress&cs=srgb&max-w=1680&max-h=1680"/>
                  </a>
                </div>

                <div>
                    <img src="https://pbs.twimg.com/media/FRnSLHeXwAMvnoZ?format=jpg&name=4096x4096"/>
                </div>

                <div>
                    <img src="https://pbs.twimg.com/media/FATYxC0WEAUb4r1?format=jpg&name=large"/>
                </div>

                <div>                   
                    <img src="https://i.imgur.com/FssODgS.jpeg"/>                   
                </div>

                <div>
                    <img src="https://i.imgur.com/IIO7yUN.jpeg"/>                  
                </div>

                <div>
                    <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/24b62acf-0cd7-4009-93ed-a0d140e5170d/deorpt1-a72d0361-b1b2-4533-954c-d4ffe385b912.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzI0YjYyYWNmLTBjZDctNDAwOS05M2VkLWEwZDE0MGU1MTcwZFwvZGVvcnB0MS1hNzJkMDM2MS1iMWIyLTQ1MzMtOTU0Yy1kNGZmZTM4NWI5MTIuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.UlcHUb1ZfmpbhVLViu4AUHBccVZ4s10pHGn84xkQGwk"/>                  
                </div>

                <div>
                  <a href="https://versum.xyz/token/versum/6605" target="_blank" rel="noopener noreferrer">
                    <img src="https://i.imgur.com/8X5hNZF.png"/>
                  </a>
                </div>

                <div>
                        <img src="https://i.imgur.com/YpW8z2A.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/2bYy9ic.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/QeJlyRS.png"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/ppN5sjY.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/j4XZtoj.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/dCoa9Za.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/x1qKIzP.jpg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/v0HeM5g.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/Vo1NK6F.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/8Hp4GP8.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/BapXfDc.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/GlRLjhN.jpeg"/>                  
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/25" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/7IDSjbZ.jpeg"/>                  
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/eCB2G2q.jpeg"/>                  
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/17" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/X3KC0hL.jpeg"/>                  
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/VllNCwv.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/Z9JVWbo.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/ggKx9FK.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/wDxXKAh.jpeg"/>                  
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/23" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/TpKsXp6.jpeg"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/10" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/jDzjkr7.jpeg"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/21" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/1cjm1lq.png"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/18" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/cRqH6Vf.jpeg"/>                  
                    </a> 
                </div>

                <div>
                    <img src="https://i.imgur.com/64CZh8Y.jpeg"/>                  
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/20" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/yxPX7Wt.png"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/9" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/DWQNOGD.jpeg"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/8" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/EyXf2ZE.jpeg"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/13" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/xXfmz1h.jpeg"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/70588876071654358432271143971228343612714605604690375153303570603557963956225" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/EwEerWO.jpeg"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/7" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/VrlMT9g.jpeg"/>                  
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/16" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/dbFW6b8.jpeg"/>                  
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/i7iJUm5.jpeg"/>                  
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/12" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/OxApZUB.jpeg"/>                  
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/2MCH1Dm.jpeg"/>                  
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/11" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/7tL0IEb.jpeg"/>                  
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/3Z8fPTs.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/YuoUGTs.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/Evu0uuq.jpeg"/>                  
                </div>

                <div>
                        <img src="https://i.imgur.com/c4gZtB9.jpeg"/>                  
                </div>

            </Masonry>
        </div>
      </>
    );
  };
  export default AnjuAllArtworkStatic;